module.exports = __webpack_public_path__ + "img/1192362-32-5.128ce336.png";